<div *ngIf="loaded ==1">
    <section ngClass.gt-sm="banner pd30  backDark " ngClass.lt-md="pdt30 pdb30  backDark">
        <div fxLayout="column" fxLayoutAlign="center center" class="fh">
            <div class="cw" fxLayout="row" fxLayoutAlign=" center" fxLayout.lt-md="column" fxLayoutGap="20px">
                <div fxLayout="column" fxLayoutAlign=" " fxFlex="60%" fxFlex.lt-md="100%" class="zIndex2">
                    <h5 class="gray-1a mgb0">{{curso.titulo}} </h5>
                    <h6 class="light-link-color ft300 mgt10 mgb10 ft16"> {{curso.resumen}}</h6>
                    <div fxLayoutAlign="start center" fxLayoutGap="20px" fxShow="true" fxShow.lt-md="false">
                        <img [src]=curso.instructorFoto class="avatar3">
                        <span href="" routerLink="/instructor/{{curso.instructorId}}"
                            class="mgt10 mgb10 chip backGray3 gray-7 cursorPointer">{{curso.instructorNombre}}</span>
                        <span *ngIf="curso.empresaNombre" routerLink="/empresa/{{curso.empresaId}}"
                            class="mgt10 mgb10 chip backGray3 gray-7 cursorPointer">{{curso.empresaNombre}}</span>
                        <span (click)="buscarCategoria()"
                            class="mgt10 mgb10 chip backBlue3 gray-2 cursorPointer">{{curso.categoria}}</span>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="space-between" class="mgt10">
                        <!-- <h6 *ngIf="porcentaje>99" class="ft500 ft17 gray-2">Progreso {{porcentaje}} %</h6> -->
                        <h6 *ngIf="porcentaje>=0" class="ft500 ft17 gray-2">Progreso {{porcentaje}} %</h6>
                    </div>
                    <mat-progress-bar mode="determinate" [value]="porcentaje"></mat-progress-bar>
                </div>
            </div>
            <div fxShow="true" fxShow.lt-md="false" class="imgDestacada"
                [ngStyle]="{ 'background-image': 'linear-gradient(60deg,rgba(21, 27, 38,1) 30%, rgba(21, 27, 38,.1) 100%), url(' + curso.foto + ')'}">
            </div>
        </div>
    </section>

    <!-- <div class="mgt60">
    <a class="blueLink mgt30 mgb20">
        <div fxLayoutAlign="start center">
            <mat-icon class="linkIcon ft16 mr05"> arrow_backward </mat-icon>
            <span class="mgl0 ft500 ft16 blueLink">Regresar a mis cursos</span>
        </div>
    </a>
</div> -->

    <section class="pdt50">
        <div fxLayout="column" class="cw" fxLayoutAlign="space-between" fxLayoutGap="20px">
            <!-- <h5 class="mgt40"> Titulo del curso aqui </h5> -->

            <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="4rem" fxLayout.lt-md="column">


                <div fxLayout="column" fxFlex="60%">
                    <h6 class="mgt0 ft500 ft17">Sesiones</h6>
                    <div class="pd05 pdr0 border-t back" *ngFor="let item of clases;  let i=index"
                        fxLayoutAlign="space-between" fxLayoutGap="1rem">

                        <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-between" fxFlex="100%"
                            fxLayoutGap="1rem" (click)="irModulo(+item.id)">
                            <div fxLayout="row" fxLayoutGap="1rem">
                                <div fxLayout="row" fxLayoutAlign="center center"  *ngIf="item.completado===1">
                                    <mat-icon class="iconBorderBlue blue-3 ft16" *ngIf="item.tipo==='video'">play_arrow
                                    </mat-icon>
                                    <mat-icon class="iconBorderBlue blue-3 ft16" *ngIf="item.tipo==='lectura' || item.tipo==='pdf'">short_text
                                    </mat-icon>
                                </div>
                                <div fxLayout="row" fxLayoutAlign="center center"  *ngIf="item.completado===0">
                                    <mat-icon class="iconBorder ft16" *ngIf="item.tipo==='video'">play_arrow
                                    </mat-icon>
                                    <mat-icon class="iconBorder ft16" *ngIf="item.tipo==='lectura' || item.tipo==='pdf'">short_text
                                    </mat-icon>
                                </div>
                                <p class="mgb0">
                                    <span class="mgb0 mgr05 ft12 gray-6">{{item.numero}}.</span>
                                    <span class="">{{item.titulo}}</span>
                                </p>
                            </div>
                            <p class="mgb0 ft12 gray-6"> {{item.duracion}} min</p>
                        </div>
                    </div>

                    <h6 class="h6Title">Examen</h6>
                    <div *ngIf="mostrarCertificado == 0">
                        <a routerLink="/est/cuestionario/{{id}}"
                            *ngIf="presentarExamen == 1 ; else elseBlockExamen">
                            <div class="pd05 pdr0 border-t back" fxLayoutAlign="space-between" fxLayoutGap="1rem">

                                <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-between" fxFlex="100%"
                                    fxLayoutGap="1rem">
                                    <div fxLayout="row" fxLayoutGap="1rem">
                                        <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderCompletado">
                                            <mat-icon class="blue-3 ft15 linkIcon">list
                                            </mat-icon>
                                        </div>
                                        <!-- <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderS">
                                <mat-icon class="light-icon-color ft15 linkIcon">
                                    play_arrow
                                </mat-icon>
                            </div> -->
                                        <a></a>
                                        <p class="mgb0">
                                            <span class="mgb0 mgr05 ft12 gray-6"></span>
                                            <span class="">Cuestionario de fin de curso</span>
                                        </p>
                                    </div>
                                    <p class="mgb0 ft12 gray-6"> {{examenPreguntas}} preguntas </p>
                                </div>

                            </div>
                        </a>
                        <ng-template #elseBlockExamen>
                            <p *ngIf="presentarExamen == 0">Aun no puedes tomar el examen. Podras tomar el examen una
                                vez hayas
                                completado todas las sesiones del
                                curso.</p>
                        </ng-template>
                    </div>
                    <div *ngIf="mostrarCertificado == 1">
                        <p>
                            Has completado el curso con éxito, descarga tu certificado.
                        </p>
                    </div>
                    <h6 class="h6Title">Certificado</h6>
                    <p *ngIf="mostrarCertificado ==0"> ¡Aprueba el examen para obtener tu certificado!</p>
                    <div *ngIf="mostrarCertificado ==1" fxLayout="row" fxLayoutGap="1rem" class="mgb10">

                        <span (click)="descargarCertificado()"
                            class="mgt10 mgb10 chip backGray3 gray-7 cursorPointer">Descargar certificado</span>
                        <span [cdkCopyToClipboard]="linkCertificado" (click)="copiaExitosa()"
                            *ngIf="progreso.certificado!==''"
                            class="mgt10 mgb10 chip backBlue5 gray-1 cursorPointer">Copiar enlace de certificado</span>

                    </div>
                    <p class="ft11 gray-7">Asegurate de que tu nombre se encuentre correctamente escrito en los datos
                        que
                        aparecen en
                        <span routerLink="/est/mi-cuenta" class="ft11 blueLink cursorPointer">Mi cuenta</span>. Este
                        sera el
                        nombre que aparecera en tu certificado.
                    </p>

                    <h6 class="h6Title">Material descargable</h6>

                    <div class="pd05 pdr0 border-t mgb0 back" *ngFor="let item of materialDescargable;  let i=index"
                        fxLayoutAlign="space-between" fxLayoutGap="1rem">

                        <!-- target="_blank"  -->
                        <!--  -->
                        <a [href]=item.url target="_blank">
                            <div fxLayout="row" fxLayoutGap="1rem" fxLayoutAlign="space-between" fxFlex="100%"
                                fxLayoutGap="1rem">
                                <div fxLayout="row" fxLayoutGap="1rem" class="">
                                    <div fxLayout="row" fxLayoutAlign="center center" class="iconBorderS">
                                        <mat-icon class="light-icon-color ft15 linkIcon">
                                            attach_file
                                        </mat-icon>

                                    </div>
                                    <span class="mgb0 ">
                                        <span class="mgb0 mgr05 ft12 gray-6">{{i}}.</span>
                                        {{item.nombre}}
                                    </span>

                                </div>
                                <!-- {{item.url}} -->
                                <span class="mgb0 ft12 gray-6"> {{item.size/1000000 | number:'1.0-2'}} MB</span>
                            </div>
                        </a>
                    </div>


                </div>


                <div fxFlex="30%">



                    <div fxLayout="row" fxLayoutGap="1rem">
                        <img [src]=curso.instructorFoto class="avatar5 ">
                        <div fxLayout="column" fxLayoutAlign="center">
                            <span>Instructor</span>
                            <a class="gray-9 ft500"> {{curso.instructorNombre}} </a>
                            <a routerLink="/instructor/{{curso.instructorId}}" class="blueLink mgt0">
                                <div fxLayoutAlign=" center">
                                    <span class="ft500 ft13 blueLink mgt0">Ver perfil</span>
                                    <mat-icon class="mgl05 linkIcon"> arrow_forward </mat-icon>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div *ngIf="curso.empresaNombre">
                        <br><br> 
                    </div>

                    <div *ngIf="curso.empresaNombre" fxLayout="row" fxLayoutGap="1rem" class="mgb30">
                        <img [src]=curso.empresaFoto class="avatarSquare5">
                        <div fxLayout="column" fxLayoutAlign="center">
                            <span>Empresa</span>
                            <a class="gray-9 ft500"> {{curso.empresaNombre}}</a>
                            <a routerLink="/empresa/{{curso.empresaId}}" class="blueLink mgt0">
                                <div fxLayoutAlign=" center">
                                    <span class="ft500 ft13 blueLink mgt0">Ver perfil</span>
                                    <mat-icon class="mgl05 linkIcon"> arrow_forward </mat-icon>
                                </div>
                            </a>
                        </div>
                    </div>



                    <h6 class="h6Title">Lo que aprenderás</h6>
                    <div *ngFor="let item of curso.queAprenderas;  let i=index">
                        <li class="ft13">{{item}}</li>
                    </div>
                    <h6 class="h6Title">Descripción del curso</h6>
                    <p> {{curso.descripcion}}
                    </p>
                    <h6 class="h6Title">A quién está dirigido</h6>
                    <p> {{curso.dirigidoA}} </p>




                    <div class="inputContainer-last mgt20" *ngIf="valorado===false">

                        <div class="inputContainer-last mgt20">
                            <h6 class="h6Title">Valorar curso</h6>
                            <p>¡Ayudanos a mejorar! Comparte tus comentarios y valoraciones sobre este curso.</p>
                            <div class="align-start">


                                <div fxLayout="row" fxLayoutAlign="center" fxLayoutGap=".5rem" class="cursorPointer"
                                    (click)="openValorarCurso()">
                                    <mat-icon class="light-icon-color ft22 linkIcon">star_border</mat-icon>
                                    <mat-icon class="light-icon-color ft22 linkIcon">star_border</mat-icon>
                                    <mat-icon class="light-icon-color ft22 linkIcon">star_border</mat-icon>
                                    <mat-icon class="light-icon-color ft22 linkIcon">star_border</mat-icon>
                                    <mat-icon class="light-icon-color ft22 linkIcon">star_border</mat-icon>
                                </div>

                            </div>
                            <br>
                            <p class="ft12 center gray-6">Tiempo promedio para responder 1 minuto</p>
                        </div>


                    </div>
                    <div class="inputContainer-last mgt20" *ngIf="valorado===true">
                        <h6 class="h6Title">Valorar curso</h6>
                        <p class="mgb0">Ya has valorado este curso.</p>
                        <a class="mgt0 gray-6 ft13 blueLink" (click)="openValorarCurso()"> ¿Deseas cambiar tu
                            valoración?</a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>
<div *ngIf="loaded ==0">
    <div *ssrExclude>
        <spinner></spinner>
    </div>
</div>